import { Theme } from '@aws-amplify/ui-react';
import { HelveticaNeue } from '@peerless/ui-assets/fonts';

import { palette } from '@peerless/ui-assets/palette';

import './theme.amplify.css';

/**
 * Amplify Theme is used for any Amplify UI components
 */
export const amplifyTheme: Theme = {
  name: 'Amplify Theme',
  tokens: {
    colors: {
      primary: {
        value: palette.primary.main,
      },
      secondary: {
        value: palette.secondary.main,
      },
    },
    fonts: {
      default: {
        variable: { value: `${HelveticaNeue.style.fontFamily}, sans-serif` },
        static: { value: `${HelveticaNeue.style.fontFamily}, sans-serif` },
      },
    },
    components: {
      authenticator: {},
      button: {
        borderRadius: '0',
        fontSize: '1.125rem',
        color: palette.primary.main,
        _hover: {
          color: '{colors.white.value}',
          backgroundColor: palette.primary.main,
          borderColor: palette.primary.main,
        },
        _active: {
          color: '{colors.white.value}',
          backgroundColor: palette.primary.main,
          borderColor: palette.primary.main,
        },
        _focus: {
          color: '{colors.white.value}',
          backgroundColor: palette.primary.main,
          borderColor: palette.primary.main,
        },
        primary: {
          color: palette.primary.main,
          backgroundColor: '{colors.white.value}',
          borderColor: palette.primary.main,
          borderWidth: '4px',
          _active: {
            backgroundColor: palette.primary.dark,
          },
          _focus: {
            backgroundColor: palette.primary.dark,
          },
          _hover: {
            backgroundColor: palette.primary.main,
          },
          _disabled: {
            backgroundColor: palette.gray.light,
            color: palette.gray.dark,
          },
        },
        link: {
          color: palette.primary.main,
          _hover: {
            color: palette.primary.main,
            backgroundColor: '{colors.white.value}',
          },
        },
      },
      tabs: {
        item: {
          _active: {
            color: palette.primary.main,
            borderColor: palette.primary.main,
          },
          _hover: {
            color: palette.primary.light,
          },
          _focus: {
            color: palette.primary.dark,
          },
        },
      },
      fieldcontrol: {
        borderColor: palette.gray.light,
        borderWidth: '4px',
        borderRadius: '0',
        _focus: {
          borderColor: palette.primary.main,
          boxShadow: `none`,
        },
        _error: {
          borderColor: palette.error.main,
        },
      },
    },
  },
};
